export default __webpack_public_path__ + "static/media/soesvinget-property-02.4d9cfc70.jpg";